import { Dialog } from '@material-ui/core';
import { ReactNode, RefObject } from 'react';
import { WebviewLayout } from 'shared/layout/WebviewLayout';
import styled from 'styled-components';

const StyledContent = styled.div`
  flex: 1;
  height: 100%;
`;

interface PostingViewModalProps {
  children: ReactNode;
  contentKey?: string;
  contentRef?: RefObject<HTMLDivElement>;
}

export function PostingDetailsModal({
  children,
  contentKey,
  contentRef,
}: PostingViewModalProps) {
  return (
    <Dialog
      open={true}
      fullScreen={true}
      disableEnforceFocus={true}
      TransitionProps={{ appear: false, exit: false }}
    >
      <WebviewLayout contentKey={contentKey} contentRef={contentRef}>
        <StyledContent>{children}</StyledContent>
      </WebviewLayout>
    </Dialog>
  );
}
